/*
 * Notice: This software is proprietary to Pocketbook, its affiliates, partners and/or
 * licensors. Unauthorized copying, distribution or use is strictly prohibited.
 * All rights reserved.
 */

'use strict';

angular.module('webReader')
    .directive('bookmarksList', function () {
        return {
            scope: {},
            restrict: 'E',
            replace: true,
            transclude: true,
            templateUrl: 'directives/bookmarkslist/bookmarkslist.view.html',
            controller: ["$scope", "DocumentModel", "DocumentService", "BookmarksModel", "$rootScope", function ($scope, DocumentModel, DocumentService, BookmarksModel, $rootScope) {
                var scope = $scope;

                scope.bookmarks = [];
               
                    BookmarksModel.create();
                    BookmarksModel.subscribe.onBookmarksUpdate(function () {
                        scope.bookmarks = BookmarksModel.getBookmarks();
                    });
                

            }]
        };
    });